import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ClientGroupForm from "./clientGroupForm";
// import { Title } from "./styles";

const ClientGroupModal = ({ toggle, isOpen, groupInfo, reload }) => {
  return (
    <div>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle} className="d-flex justify-content-center border-0 pb-1">
          {/* <Title>Cliente</Title> */}
        </ModalHeader>
        <ModalBody>
          <ClientGroupForm toggle={toggle} groupInfo={groupInfo} reload={reload} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ClientGroupModal;
